import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class AvaluosService {

  private service_url;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/avaluos';
  }

  get(idCreditos : number) {
    let serviceUrl = this.service_url + '?idCreditos='+ idCreditos;

    return this.http.get(serviceUrl , this.authService.getAuthHeaders());
  }

  public save( avaluo : object) {
    return this.http.post(this.service_url , avaluo, this.authService.getAuthHeaders());
  }

  public update( avaluo : object) {
    return this.http.put(this.service_url , avaluo, this.authService.getAuthHeaders());
  }

  public validate(data : any, idTipos_Creditos : number){
    let error = [];
    
    if(!this.validatorService.required(data.valor)){
      error["valor"] = this.errorService.required;
    }    
    
    if(!this.validatorService.required(data.descripcion)){
      error["descripcion"] = this.errorService.required;
    }

    if(idTipos_Creditos === 1){
      //Validaciones para el crédito hipotecario 
      if(!this.validatorService.required(data.escritura)){
        error["escritura"] = this.errorService.required;
      }
      if(!this.validatorService.required(data.notaria)){
        error["notaria"] = this.errorService.required;
      }
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/avaluos.service.ts